import React, { useRef, useEffect } from "react";

function VideoPlayer(props) {
  const {
    src,
    freeCourse,
    toggleModalLesson,
    handleLessonEnded,
    setIsModalAlertOpen,
  } = props;

  const videoRef = useRef();
  const previousSrc = useRef(null);

  // Forza il reload e il play del video quando cambia `src`
  useEffect(() => {
    const video = videoRef.current;

    if (src !== previousSrc.current && video) {
      previousSrc.current = src;

      // Forza autoplay solo quando il video è pronto
      const handleCanPlay = () => {
        video.muted = true; // forza muted per policy browser
        video
          .play()
          .then(() => {
            console.log("✅ Autoplay video avviato");
          })
          .catch((err) => {
            console.warn("❌ Autoplay fallito:", err);
          });
      };

      video.addEventListener("canplaythrough", handleCanPlay, { once: true });
    }
  }, [src]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    let supposedCurrentTime = 0;

    const handleTimeUpdate = () => {
      if (!video.seeking) {
        supposedCurrentTime = video.currentTime;
      }
    };

    const handleSeeking = () => {
      const delta = video.currentTime - supposedCurrentTime;
      if (delta > 0.01 && freeCourse === 0) {
        video.currentTime = supposedCurrentTime;
      }
    };

    const handleEnded = () => {
      handleLessonEnded();
      toggleModalLesson(false);
      setIsModalAlertOpen(false);
    };

    video.addEventListener("timeupdate", handleTimeUpdate);
    video.addEventListener("seeking", handleSeeking);
    video.addEventListener("ended", handleEnded);

    if (freeCourse === 1) {
      handleLessonEnded();
    }

    return () => {
      video.removeEventListener("timeupdate", handleTimeUpdate);
      video.removeEventListener("seeking", handleSeeking);
      video.removeEventListener("ended", handleEnded);
    };
  }, [freeCourse, handleLessonEnded, setIsModalAlertOpen, toggleModalLesson]);

  return (
    <video
      ref={videoRef}
      autoPlay
      muted
      playsInline
      controls
      width="100%"
      height="100%"
      style={{ maxHeight: "80vh" }}
      poster="/images/logo.png"
    >
      <source src={src} type="video/mp4" />
      Il tuo browser non supporta la riproduzione video.
    </video>
  );
}

export default VideoPlayer;
